import React, { Component } from 'react'
import './download-certificate.scss'
import { ImageConstants, Constants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import SessionCache from '../../routes/session-cache'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faFileDownload } from '@fortawesome/free-solid-svg-icons'
import ClassFilter from '../class-filter/class-filter'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import SchoolApi from '../../../apis/school'
import URL from '../../../apis/url';
import { Modal, ModalBody } from 'reactstrap'

class DownloadCertificate extends Component {
  state = {
    selectedClass: 'All',
    imdStudents: [],
    meta: { totalPages: 1, page: 1 }
  }
  data = []
  limit = 10
  page = 1
  constructor (props) {
    super(props)

    let userName = SessionCache.getName()

    this.name = userName

    let user = SessionCache.getUser()
    this.user = user

    this.getStudentParticipatedList({})
  }

  getStudentParticipatedList = (payload = {}) => {
    const { selectedClass } = this.state
    this.setState({
      isLoading: true
    })
    payload.eventId = Constants.IMD_EVENT_ID
    if (!payload.class && selectedClass && selectedClass !== 'All')
      payload.class = selectedClass
    if (!payload.page) payload.page = 1
    if (!payload.limit) payload.limit = this.limit

    this.currentPage = payload.page

    if (this.currentPage === 1) this.startIndex = 1

    SchoolUserApi.getIMDWinnersList(payload)
      .then(result => {
        this.setState({
          imdStudents: result.response,
          meta: result.meta,
          isLoading: false,
          basePath: result.basePath
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  hideModal = () => {
    this.setState({
      showInviteStudents: false,
      showInviteTeachers: false
    })
  }

  onContinue = _ => {
    this.hideModal()
  }

  onSelectClass = title => {
    this.setState(
      {
        selectedClass: title || 'All'
      },
      _ => {
        this.getStudentParticipatedList({})
      }
    )
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }

  goBack = _ => {
    this.props.goBack()
  }

  onPageSelected = (selectedPage, startIndex) => {
    this.startIndex = startIndex
    this.page = selectedPage
    this.setState({ selectedPage })
    this.getStudentParticipatedList({page: this.page})
  }

  downloadAllPerformanceReports = _ => {
    
    const { selectedClass } = this.state
    this.setState({
      isDownloadLoading: true,
      loaderHeaderText: "Downloading Performance Reports"
    }, _ => {
      const payload = {
        eventId: Constants.IMD_EVENT_ID
      }
      if (selectedClass && selectedClass !== 'All') payload.class = selectedClass

      SchoolApi.downloadAllPerformanceReports(payload)
        .then(result => {
            this.setState({isDownloadLoading: false}, _ => {
              console.log(URL.BASE_URL + "/" + result.data.path)
              window.open(URL.BASE_URL + "/" + result.data.path, "_blank")
              alert("Downloaded Successfully");
            })
            // this.showToaster('success', 'Certificates downloaded successfully')
        })
        .catch(err => {
          this.setState({isDownloadLoading: false})
          this.showToaster('success', 'Something went wrong')
        })
    })
  }

  downloadAllCertificates = type => {
    const { selectedClass } = this.state
    this.setState({
      isDownloadLoading: true,
      loaderHeaderText: "Downloading Certificates"
    }, _ => {
      const payload = {
        type,
        eventId: Constants.IMD_EVENT_ID
      }
      if (selectedClass && selectedClass !== 'All') payload.class = selectedClass

      SchoolApi.downloadAllCertificates(payload)
        .then(result => {
            this.setState({isDownloadLoading: false}, _ => {
              // this.showToaster('success', 'Certificates downloaded successfully')
              window.open(URL.BASE_URL + "/" + result.data.path, "_blank")
              alert("Downloaded Successfully");
            })
        })
        .catch(err => {
          this.setState({isDownloadLoading: false})
          this.showToaster('success', 'Something went wrong')
        })
    })
  }

  downloadCertificate = (item, type) => {
    this.setState({
      isDownloadLoading: true,
      loaderHeaderText: "Downloading Certificate"
    }, _ => {
      const payload = {
        type,
        user_id: item.userId,
        transfer_key: item.transferKey,
        rank: item.rank,
        eventId: Constants.IMD_EVENT_ID
      }
      SchoolApi.downloadCertificate(payload)
        .then(result => {
          this.setState({isDownloadLoading: false}, _ => {
            window.open(result.data.url, "_blank")
            alert("Downloaded Successfully");
          })
        })
        .catch(err => {
          this.setState({isDownloadLoading: false}, _ => {
            this.showToaster('success', 'Something went wrong')
          })
        })
    })
  }

  getCertificateType = (rank) => {
    if (rank <= 3) return "Winners"
    if (rank > 3 && rank <= 10) return "Top 10 rankers"
    if (rank > 10 && rank <= 30) return "Top 30 rankers"
    if (rank > 30 && rank <= 75) return "Top 75 rankers"
    if (rank > 75 && rank <= 150) return "Top 150 rankers"
    if (rank > 150 && rank <= 250) return "Top 250 rankers"
    if (rank > 250 && rank <= 500) return "Enthusiast"
}

  render () {
    const { selectedClass, imdStudents, loaderHeaderText, isDownloadLoading, isLoading, meta } = this.state
    return (
      <div className='performance download-certificate'>
        <div className='header-container'>
          
          <div className='row'>
            <div
              className='col-1 back-icon cursor-pointer'
              onClick={this.goBack}
            >
              <FontAwesomeIcon icon={faArrowLeft} color='#1C1C1C' />
            </div>
            <div className='col-12 pb-2'>
              <span className='screen-title'>Download Certificates & Reports</span>
            </div>
            <div className='col-12 mb-3 text-right'>
              <span>
                <button
                  className='cw-btn-md d-inline-block cw-btn-primary mr-2'
                  onClick={_ => this.downloadAllCertificates('PARTICIPATION')}
                >
                  DOWNLOAD ALL PARTICIPATION CERTIFICATE
                </button>
              </span>
              <span>
                <button
                  className='cw-btn-md d-inline-block cw-btn-success mr-2'
                  onClick={_ => this.downloadAllCertificates('WINNERS')}
                >
                  DOWNLOAD ALL WINNERS CERTIFICATE
                </button>
              </span>
              <span>
                <button
                  className='cw-btn-md d-inline-block cw-btn-primary mr-2 mt-2'
                  onClick={_ => this.downloadAllPerformanceReports()}
                >
                  DOWNLOAD ALL PERFORMANCE REPORT
                </button>
              </span>
            </div>
          </div>
        </div>
        <ClassFilter
          onSelectClass={this.onSelectClass}
          selectedClass={selectedClass}
        />
        <div className='container-fluid'>
          <div className='mt-5'>
            <div id='table-scoll' className='table-responsive mt-5'>
              {isLoading && (
                <Loading style={{ top: '100px' }}></Loading>
              )}
              <table className='table cw-table mb-0 align-items-center student-winners'>
                <thead>
                  <tr>
                    <th className='text-center th-left-radius'>Sr. No</th>
                    <th className='text-center'>Name</th>
                    <th className='text-center'>Score</th>
                    <th className='th-right-radius'>Download Certificate</th>
                  </tr>
                </thead>
                <tbody className='bg-white'>
                  {imdStudents.length > 0 &&
                    imdStudents.map((student, index) => (
                      <tr key={index} className='mt-4'>
                        <td className='student-rank text-center'>{(index + 1) + ((this.currentPage - 1) * 10)}</td>
                        <td className='text-center'>{student.name}</td>
                        <td className='text-center'>
                          <strong>{student.markScored}</strong>
                        </td>
                        <td className=''>
                          <span
                            onClick={_ =>
                              this.downloadCertificate(student, 'PARTICIPATION')
                            }
                            className='download-text'
                          >
                            <img
                              className='download-icn'
                              src={getImageSource(
                                ImageConstants.DOWNLOAD_ICON_BLUE
                              )}
                            />
                            PARTICIPATION
                          </span>
                          {student.rank <= 500 &&
                            <span
                              onClick={_ =>
                                this.downloadCertificate(student, 'WINNERS')
                              }
                              className='download-text'
                            >
                              <img
                                className='download-icn'
                                src={getImageSource(
                                  ImageConstants.DOWNLOAD_ICON_BLUE
                                )}
                              />
                              {this.getCertificateType(student.rank)}
                            </span>
                          }
                          {student?.performanceReportUrl &&
                            <span
                              onClick={_ =>
                                window.open(student?.performanceReportUrl, "_blank")
                              }
                              className='download-text'
                            >
                              <img
                                className='download-icn'
                                src={getImageSource(
                                  ImageConstants.DOWNLOAD_ICON_BLUE
                                )}
                              />
                              PERFORMANCE REPORT
                            </span>
                          }
                        </td>
                      </tr>
                    ))}
                  {!imdStudents.length && (
                    <tr className='mt-4'>
                      <td colSpan='8' className='text-center'>
                        {' '}
                        No Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {!isLoading && meta.totalPages !== 0 && (
                <div className='card-footer'>
                  <PaginationComponent
                    startIndex={this.startIndex}
                    selectedPage={this.currentPage}
                    totalPages={meta.totalPages}
                    onPageSelected={this.onPageSelected.bind(this)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {isDownloadLoading && (
          <Modal className="cw-custom-modal" isOpen={isDownloadLoading} size={'md'}>

            <ModalBody >
                <div className="add-admin">
                    <div className="header-text text-center">
                        <span>{loaderHeaderText}</span>
                    </div>
                    <div className='row px-5 py-5 margin-auto'>
                        <img
                            className='loader-icn'
                            src={getImageSource(
                              ImageConstants.PRE_LOADER_GIF
                            )}
                          />
                    </div>
                </div>
            </ModalBody>

        </Modal >
        )}
      </div>
    )
  }
}

export default DownloadCertificate
